import React from 'react';

export default function SolutionsIcon() {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7879 21.8717H2.16914V1.80918H20.6941V13.1154L22.4941 13.0967V2.27793C22.4941 1.09668 21.4629 0.0654297 20.2816 0.0654297H2.58164C1.40039 0.0654297 0.369141 1.09668 0.369141 2.27793V21.4498C0.369141 22.6311 1.40039 23.6623 2.58164 23.6623H11.7691L11.7879 21.8717Z"
        fill="#60EC2F"
      />
      <path
        d="M5.6375 13.8277C5.3375 13.8277 5.09375 13.584 5.09375 13.284C5.09375 12.984 5.3375 12.7402 5.6375 12.7402H10.8031C11.1031 12.7402 11.3469 12.984 11.3469 13.284C11.3469 13.5746 11.1031 13.8277 10.8031 13.8277H5.6375Z"
        fill="#60EC2F"
      />
      <path
        d="M5.6375 17.2213C5.3375 17.2213 5.09375 16.9775 5.09375 16.6775C5.09375 16.3775 5.3375 16.1338 5.6375 16.1338H8.36563C8.66563 16.1338 8.90937 16.3775 8.90937 16.6775C8.90937 16.9682 8.66563 17.2213 8.36563 17.2213H5.6375Z"
        fill="#60EC2F"
      />
      <path
        d="M5.6375 10.4342C5.3375 10.4342 5.09375 10.1904 5.09375 9.89043C5.09375 9.59043 5.3375 9.34668 5.6375 9.34668H14.2719C14.5625 9.34668 14.8156 9.59043 14.8156 9.89043C14.8156 10.1811 14.5719 10.4342 14.2719 10.4342H5.6375Z"
        fill="#60EC2F"
      />
      <path
        d="M5.6375 7.04941C5.3375 7.04941 5.09375 6.80566 5.09375 6.50566C5.09375 6.21504 5.3375 5.96191 5.6375 5.96191H16.9531C17.2437 5.96191 17.4969 6.20566 17.4969 6.50566C17.4969 6.80566 17.2531 7.04941 16.9531 7.04941H5.6375Z"
        fill="#60EC2F"
      />
      <path
        d="M17.3762 13.9219C14.7793 13.9219 12.6699 16.0313 12.6699 18.6281C12.6699 21.225 14.7793 23.3344 17.3762 23.3344C19.973 23.3344 22.0824 21.225 22.0824 18.6281C22.0918 16.0313 19.9824 13.9219 17.3762 13.9219ZM20.1699 17.475L16.7574 20.8875C16.523 21.1219 16.1387 21.1219 15.9043 20.8875L14.5168 19.5C14.2824 19.2656 14.2824 18.8813 14.5168 18.6469C14.7512 18.4125 15.1355 18.4125 15.3699 18.6469L16.3262 19.6031L19.3168 16.6125C19.5512 16.3781 19.9355 16.3781 20.1699 16.6125C20.4043 16.8656 20.4043 17.2406 20.1699 17.475Z"
        fill="#60EC2F"
      />
      <path
        d="M20.6934 13.0494C20.6934 13.5463 21.0965 13.9494 21.5934 13.9494C22.0902 13.9494 22.4934 13.5463 22.4934 13.0494C22.4934 12.5525 22.0902 12.1494 21.5934 12.1494C21.0965 12.1494 20.6934 12.5525 20.6934 13.0494Z"
        fill="#60EC2F"
      />
      <path
        d="M10.8418 22.7721C10.8418 23.2689 11.2449 23.6721 11.7418 23.6721C12.2387 23.6721 12.6418 23.2689 12.6418 22.7721C12.6418 22.2752 12.2387 21.8721 11.7418 21.8721C11.2449 21.8721 10.8418 22.2752 10.8418 22.7721Z"
        fill="#60EC2F"
      />
    </svg>
  );
}
